<div class="overlay-container">
  <div class="overlay-header flex flex-row justify-between items-center">
    <h1>{{ '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.TITLE' | translate }}</h1>
    <div class="flex flex-row items-center gap-2 mr-4">
      <button
        mat-stroked-button
        (click)="back()"
        class="lt-md:!hidden"
        gtm="onBack"
        gtmAction="Back to HEMS settings"
        gtmCategory="hems"
      >
        <mat-icon>arrow_back</mat-icon>
        <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.BACK_BUTTON' | translate }}</span>
      </button>
      <button
        mat-stroked-button
        (click)="close()"
        class="lt-md:!hidden"
        gtm="onClose"
        gtmAction="Close PV power prioritization"
        gtmCategory="hems"
      >
        <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
        <mat-icon iconPositionEnd>close</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="back()"
        class="!hidden lt-md:!inline-flex"
        gtm="onBack"
        gtmAction="Back to HEMS settings"
        gtmCategory="hems"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="close()"
        class="!hidden lt-md:!inline-flex"
        gtm="onClose"
        gtmAction="Close PV power prioritization"
        gtmCategory="hems"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="wrapper">
    <p>{{ '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.DESCRIPTION' | translate }}</p>
    <a class="learn-more-link" (click)="openLearnMore()">
      {{
        '+INSTALLATIONS.INSTALLATION.HEMS.ENERGY_COCKPIT.CONSUMPTION_LIMITATION.LINK_LABEL'
          | translate
      }}
    </a>

    <div class="device-list">
      <div class="device-card">
        <div class="device-card__info">
          <div class="device-card__title-row">
            <span class="device-card__name">
              {{ '+HEMS_FEATURES.EMS.ENERGY.CONSUMPTION.HOUSEHOLD' | translate }}
            </span>
          </div>
        </div>

        <div class="device-card__actions">
          <ng-container>
            <mat-icon class="device-card__lock-icon">lock</mat-icon>
          </ng-container>
        </div>
      </div>
      <div *ngFor="let device of devices; let i = index" class="device-card">
        <div class="device-card__info">
          <div class="device-card__title-row">
            <span class="device-card__name">{{ device.name }}</span>
            <mat-icon
              *ngIf="device.infoKey.length"
              class="device-card__info-icon"
              [matTooltip]="device.infoKey | translate"
              matTooltipClass="multiline-tooltip"
              >info_outline</mat-icon
            >
          </div>
          <span *ngIf="device.subTitleKey?.length" class="device-card__subtitle">
            {{ device.subTitleKey | translate }}
          </span>
        </div>

        <div class="device-card__actions">
          <ng-container *ngIf="device.isLocked; else moveButtons">
            <mat-icon class="device-card__lock-icon">lock</mat-icon>
          </ng-container>
          <ng-template #moveButtons>
            <mat-icon *ngIf="device.isWarningIconVisible" class="device-card__warning-icon"
              >warning</mat-icon
            >
            <button
              mat-icon-button
              class="device-card__move-btn"
              [disabled]="!device.canMoveUp"
              (click)="moveUp(i)"
            >
              <mat-icon>expand_less</mat-icon>
            </button>
            <button
              mat-icon-button
              class="device-card__move-btn"
              [disabled]="!device.canMoveDown"
              (click)="moveDown(i)"
            >
              <mat-icon>expand_more</mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="save-button-container">
      <button
        [disabled]="!isDirty"
        (click)="onSave()"
        mat-raised-button
        color="primary"
        class="save-btn"
      >
        {{ 'GENERAL.BUTTON.SAVE' | translate }}
      </button>
      <a class="restore-link" (click)="restoreDefaults()">
        {{ '+HEMS.SETTINGS.OPTIMIZATIONS.PV_POWER_PRIORITIZATION.RESTORE_DEFAULT' | translate }}
      </a>
    </div>
  </div>
</div>
